import getArweaveContentUrl from 'utils/getArweaveContentUrl';
import { inTextEllipsisCenter } from 'utils/text-ellipsis-center';
import { ArticleIntegrationLink } from '../ArticleIntegrationLink/ArticleIntegrationLink';

export const ArweaveTransactionLink = ({ arweaveId }: { arweaveId: string }) => (
  <ArticleIntegrationLink icon={<div className="w-5 h-5 content-arweaveLogo" />} href={getArweaveContentUrl(arweaveId)}>
    Arweave: {inTextEllipsisCenter(arweaveId, 15, 15)}
  </ArticleIntegrationLink>
);
